// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Vca-z","subtitle":"Wca-z","wrapper":"Xca-z","leftArrow":"Yca-z","rightArrow":"Zca-z"};